import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Home } from "@/pages/Home";
import { Create } from "@/pages/Create";
import { Blog } from "@/pages/Blog";
import { BlogPost } from "@/pages/BlogPost";
import { Admin } from "@/pages/Admin";
import { Terms } from "@/components/Terms";
import { ContentPage } from "@/pages/ContentPage";
import { CONTENT_PAGES } from "@/pages/content";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-white flex flex-col">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Header />
        <ScrollToTop />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/create" element={<Create />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/terms" element={<Terms />} />
            {Object.entries(CONTENT_PAGES).map(([key, page]) => (
              <Route key={key} path={page.path} element={<ContentPage page={page} />} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
